import { Image } from './image.model';
import { Message } from './message.model';
import { Patient } from './patient.model';
import { Prontuary } from './prontuary.model';
import { Report } from './report.model';
import { User } from './user.model';

export class ExamRequest {
  id: number = -1;
  code: string = '';
  patient: Patient | null | undefined = null;
  assigned_to: User | null | undefined = null;
  images: Image[] = [];
  messages: Message[] = [];
  creator: User | null | undefined = null;
  status: string = 'NOT_STARTED';
  prontuary: Prontuary | null = null;
  report: Report | null = null;
  tissue_related: string = '';
  urgent: boolean = false;
  created_at: string = '';
  finished_at: string | null = null;
  description: string = '';
  num_images_from_lis: number = 0;
  num_digitalized: number = 0;
  from_same_block_images: Image[] = [];
}
